import { render } from "./transfer-master-setting.vue?vue&type=template&id=37c22b31&scoped=true"
import script from "./transfer-master-setting.vue?vue&type=script&lang=js"
export * from "./transfer-master-setting.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./transfer-master-setting.vue?vue&type=style&index=1&id=37c22b31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c22b31"]])

export default __exports__